import { jsx as _jsx } from "react/jsx-runtime";
import { Box as ChakraBox, forwardRef, } from '@chakra-ui/react';
/**
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/box
 */
export const Box = forwardRef((props, ref) => {
    return (_jsx(ChakraBox, { ...props, ref: ref, children: props.children }));
});
//# sourceMappingURL=box.js.map